define('commons/monitoring/base-monitoring',['jquery', 'utils/form', 'dygraph'], function($, form) {

    var BaseMonitoring = function(containerId, mapping, autoStart, drawOptions, transformers, opts, masterResolutionSelectorId) {

        this.mapping = mapping;
        this.drawOptions = drawOptions;
        this.transformers = transformers ? transformers : {};
        var archives = [];
        if (this.mapping && this.mapping.keys) {
            var uniques = {};
            var idx = -1;
            for (var i = 0; i < this.mapping.keys.length; i++) {
                var key = this.mapping.keys[i];
                if ((idx = key.indexOf(":")) > -1) {
                    key = key.substring(0, idx);
                }
                if (!uniques[key]) {
                    archives.push(key);
                    uniques[key] = true;
                }
            }
            if (this.mapping.keys.length == 1) {
                this.wildcardKey = this.mapping.keys[0] === '*';
            }
        }
        if (this.wildcardKey) {
            // archives must be provided in opts
            this.params = opts;
        } else {
            this.params = $.extend({}, {
                archives: archives
            }, opts);
        }
        this.identity = function(data) {
            return data;
        };

        // Attributes
        this.container = $('#'+containerId);
        this.label = this.container.find(".monitoring-label");
        this.chart = this.container.find(".monitoring-graph-container");
        this.chart.data('height', this.chart.css('height'));
        this.dygraph = null;
        this.masterResolutionSelector = $('#' + (masterResolutionSelectorId || 'master-resolution-selector'));

        this.init();
        if (autoStart) {
            this.refresh();
        }
        form.disableSelection(this.container[0]);
    };

    var flattenGraph = function(graph) {
        var path = [];

        var properties = Object.getOwnPropertyNames(graph);
        var headFactor = 0;
        while (properties.length > 0) {
            var heads = properties.filter(r => properties.map(r2 => graph[r2]).filter(arr => arr.indexOf(r) >= 0).length <= headFactor);
            if (heads.length > 0) {
                headFactor = 0;
                var head = heads[0];
                path.push(head);
                properties = properties.filter(r => r != head);
            } else {
                headFactor++;
            }
        }

        return path;
    };

    BaseMonitoring.prototype.init = function() {
        // Init events
        this.select = this.container.find("select.monitoring-select");
        
        if (this.masterResolutionSelector.length > 0) {
            var graphResolutions = this.select.find('option').map(function() { return $(this).text(); }).filter(function() { return this.trim().length > 0; }).toArray();
            
            if (graphResolutions.length > 0) {
                var resolutionLabel = this.select.data('label') || 'Resolution';

                var optGroup = this.masterResolutionSelector.find('optgroup[label="' + resolutionLabel + '"]');
                if (optGroup.length == 0) {
                    optGroup = $('<optgroup></optgroup>').prop('label', resolutionLabel);
                    this.masterResolutionSelector.append(optGroup);
                }
                
                var masterGraph = optGroup.data('graph') || {};
                for (var i = 0; i < graphResolutions.length; i++) {
                    var curr = graphResolutions[i];
                    var next = i + 1 < graphResolutions.length ? graphResolutions[i+1] : undefined;

                    if (!masterGraph[curr]) {
                        masterGraph[curr] = [];
                    }
                    if (next && masterGraph[curr].indexOf(next) < 0) {
                        masterGraph[curr].push(next);
                    }
                }
                optGroup.data('graph', masterGraph);

                var masterOptions = flattenGraph(masterGraph);

                optGroup.empty();
                for (var i = 0; i < masterOptions.length; i++) {
                    optGroup.append($('<option></option>').text(masterOptions[i]));
                }
                
                // listen on master selector to apply change to current graph
                var self = this;
                this.masterResolutionSelector.change(function(e) {
                    var index = graphResolutions.indexOf(this.value);
                    if (index >= 0) {
                        self.select.prop("selectedIndex", index);
                        self.select.trigger('change');
                    }
                });
            }
        }
        
        this.select.change($.proxy(function() {
            this.loadData();
        }, this));
    };

    BaseMonitoring.prototype.getURL = function() {
        return this.select.val();
    };

    BaseMonitoring.prototype.refresh = function() {
        this.select.change();
    };

    BaseMonitoring.prototype.loadData = function(params) {
        if (params) {
            $.extend(this.params, params);
        }
        this.chart.addClass("loading");
        $.ajax({
            type: 'GET',
            url: this.getURL(),
            dataType: 'json',
            data: this.params,
            context: this,
            traditional: true,
            success: function(data) {
                var result = this.processResponse(data);
                if (result && result.data.length > 0) {
                    if (this.dygraph === null) {
                        // If no draw options defined while processing data, use the one defines when the object was built
                        var drOpts = result.drawOptions || this.drawOptions;
                        this.chart.css("text-align", "left").css("height", this.chart.data('height')).empty();
                        this.dygraph = new Dygraph(this.chart.get(0), result.data, $.extend({
                            labels: result.labels,
                            fillGraph: true,
                            labelsDiv: this.label.get(0),
                            hideOverlayOnMouseOut: false,
                            legend: "always",
                            axisLabelFontSize: 12
                        }, drOpts));
                    } else {
                        this.dygraph.updateOptions({
                            labels: result.labels,
                            file: result.data
                        });
                    }
                } else {
                    this.chart.css("text-align", "center").css("height", "auto").html("No data to display");
                    this.dygraph = null;
                }
                this.chart.removeClass("loading");
            },
            error: function(error) {
                this.chart.css("text-align", "center").css("height", "auto").html(error.responseJSON.error);
                this.dygraph = null;
                this.chart.removeClass("loading");
            }
        });
    };

    BaseMonitoring.prototype.processResponse = function() {
        // TO BE OVERRIDDEN
    };

    return BaseMonitoring;
});
